import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { UserMyRadiant as User, Me, RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { Camera } from '@ionic-native/camera';


import { File } from '@ionic-native/file';
import * as mapboxgl from 'mapbox-gl';
import { PhotoViewer } from '@ionic-native/photo-viewer';

@Component({
  selector: 'detail-idle',
  templateUrl: 'page.html'
})
export class DetailIdle {
  loading : any;
  activeTab = 'certificate';
  data = {
    preview_img : './assets/img/no_img.jpg',
    style : 'mapbox://styles/mapbox/outdoors-v9',
    pegawai:{},
    general:{},
    certificate:[]
  };
  filePermit:any;
  map = mapboxgl.Map;
  parameter: any = {
    
  };
  stateRequest: number;
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public activityProvider   : Me,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public camera             : Camera,
    public file               : File, 
    public api                : ApiMyRadiant,
    public photoviewer        : PhotoViewer,
    ) {
    this.config.set('backButtonText','Detail');
    // this.getListType();
    let params = this.navParams.get('data');
    this.data.general = params;
    this.data.pegawai = params;
    this.parameter.id =  params['employee_id'];
    this.parameter.user_code =  params['code'];
    this.parameter.nik =  params['code'];
    this.getCeritificate();
    
  }

  changeTab(tab){
    this.activeTab = tab;
    localStorage.setItem('activeTabIdle',tab);
  }

  getCeritificate(){
    let me = this;
    this.repositoryProvider.getProfilCeritificate(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.certificate = resp.data;
      }
    },(err) => {
      this.helper.presentToast("Erorr");
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }
}



// WEBPACK FOOTER //
// ./src/pages/activity/idle/detail/page.ts